module.exports = __webpack_public_path__ + "img/imgYLSYB(3).178b8861.png";